import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./views/home";
import Leightons from "./views/leightons";
import ArcherArts from "./views/archer-arts";
import KaneFM from "./views/kane-fm";
import Powerhouse from "./views/powerhouse";
import ScrollToTop from "./components/scroll-to-top";
import FooterBanner from "./components/footer-banner";
import Menu from "./components/nav-menu";

const App: React.FC = () => {
  return (
    <Router>
      <Menu />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/leightons" element={<Leightons />} />
        <Route path="/archer-arts" element={<ArcherArts />} />
        <Route path="/kane-fm" element={<KaneFM />} />
        <Route path="/powerhouse" element={<Powerhouse />} />
      </Routes>
      <FooterBanner />
    </Router>
  );
};

export default App;
